import { render, staticRenderFns } from "./AuthToken.vue?vue&type=template&id=8db4c470&class=token%20container&"
import script from "./AuthToken.vue?vue&type=script&lang=js&"
export * from "./AuthToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports